module.exports = __webpack_public_path__ + "img/16m009-08.4405bd9f.jpg";